import { FunctionOfHealthcare } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { InteractiveTable, InteractiveTableCellProps } from '@dreryk/react-components';

import { healthcareOrganizationTranslationKeys } from '../../../../../translations';

import {
   functionOfHealthcareItemRenderer,
   functionOfHealthcareKeyExtractor,
   functionOfHealthcareLabelExtractor,
   functionOfHealthcareSearchCreator,
} from './FunctionOfHealthcareAutosuggestCell.utils';

type FunctionOfHealthcareAutosuggestCellProps = InteractiveTableCellProps<FunctionOfHealthcare>;

export const FunctionOfHealthcareAutosuggestCell = (props: FunctionOfHealthcareAutosuggestCellProps): JSX.Element => {
   return (
      <InteractiveTable.AutosuggestCell<FunctionOfHealthcare>
         testId={props.testId}
         name={props.name}
         index={props.index}
         defaultValue={props.defaultValue}
         itemRenderer={functionOfHealthcareItemRenderer}
         textInputValueExtractor={functionOfHealthcareLabelExtractor}
         keyExtractor={functionOfHealthcareKeyExtractor}
         searchCreator={functionOfHealthcareSearchCreator}
         placeholder={healthcareOrganizationTranslationKeys.searchByCodeOrName}
         minChars={0}
      />
   );
};
